import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PriceLIstData, PriceListingstData } from '../utils/TypesPriceList';
import ComponentPriceEditDialog from './ComponentPriceEditDialog';
import DataTable from '../../../../Common/DataTable';
import { RootState } from '../../../../redux/rootState';
import { getSystemPriceStart } from '../Redux/slicePriceList';
import { setLoader } from '../../../../redux/loaderSlice';
import { defaultPageSize } from '../../../../utils/Constant';

function ComponentPriceListTable() {
  const dispatch = useDispatch();

  const { SystemPriceList, isLoading } = useSelector((state: RootState) => state.SystemPriceListReducer);

  const [rowwId, setRowwId] = useState('');

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');

  const [open, setOpen] = useState(false);

  const handleAction = (id: string) => {
    setOpen(!open);
    setRowwId(id);
  };

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(getSystemPriceStart(params));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  const TableColumns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'SerialNo', label: 'PL Id' },
      { key: 'KitDescription', label: 'Description' },
      { key: 'MeasurementType', label: 'Parameter for Measurement' },
      { key: 'Price', label: 'Price' },
      // { key: 'FixedPrice', label: 'Fixed Price' },
    ],
    [],
  );
  const tableData: PriceLIstData[] = useMemo(() => SystemPriceList?.Data?.map((item: PriceListingstData, index: number) => {
    const transformedDataItem = {
      sn: index,
      action: 'edit',
      SerialNo: item?.SerialNo,
      KitDescription: item?.KitDescription,
      MeasurementType: item?.MeasurementType,
      Price: `$ ${item?.Price}`,
      // FixedPrice: item?.FixedPrice,

      TubeAvailable: item?.TubeAvailable,
      Quantity: item?.Quantity,

      id: String(item?.Id),
    };
    return transformedDataItem;
  }), [SystemPriceList]);

  return (
    <>

      <DataTable<PriceLIstData>
        // checkBoxColumns={['FixedPrice']}
        data={tableData}
        columns={TableColumns}
        totalRecords={SystemPriceList?.TotalRecords}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleData={handleData}
        tableHeader="Variables for Price List"
        handleEdit={handleAction}
        handleDataFromComponent
      />
      <ComponentPriceEditDialog show={open} setOpenFrom={() => setOpen(false)} rowId={rowwId} />
    </>
  );
}

export default ComponentPriceListTable;
